import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="siteFooter">
      <p>&copy; {new Date().getFullYear()} 謎解きポータル. All rights reserved.</p>
      <p>Privacy Policy | Terms of Service</p>
    </footer>
  );
}

export default Footer;
